const geistConstants = {
  fonts: {
    primary: 'Geist-Regular',
    primaryBold: 'Geist-SemiBold',
    primarySemiBold: 'Geist-Medium',
  },
  fontSizes: {
    h1: 36,
    h2: 24,
    large: 18,
    medium: 16,
    small: 14,
    xsmall: 12,
  },
};

const GEIST = {
  ...geistConstants,
  typography: {
    h1: {
      fontFamily: geistConstants.fonts.primaryBold,
      fontSize: geistConstants.fontSizes.h1,
      lineHeight: 40,
    },
    h2: {
      fontFamily: geistConstants.fonts.primaryBold,
      fontSize: geistConstants.fontSizes.h2,
      lineHeight: 30,
    },
    large: {
      fontFamily: geistConstants.fonts.primary,
      fontSize: geistConstants.fontSizes.large,
      lineHeight: 22,
    },
    medium: {
      fontFamily: geistConstants.fonts.primary,
      fontSize: geistConstants.fontSizes.medium,
      lineHeight: 20,
    },
    small: {
      fontFamily: geistConstants.fonts.primary,
      fontSize: geistConstants.fontSizes.small,
      lineHeight: 18,
    },
    xsmall: {
      fontFamily: geistConstants.fonts.primary,
      fontSize: geistConstants.fontSizes.xsmall,
      lineHeight: 16,
    },
  },
};

module.exports = {
  geist: GEIST,
};
